import BarChart from 'common/components/charts/bar-chart';
import React from 'react';
import { generateColors, getValueFromPercent } from 'utils/helpers';

interface IProps {
    type: 'horizontal' | 'vertical';
    showLabel: boolean;
    data: { name: string; value: number; value_percent: number }[];
    total: number;
}

const QuestionStackedColumnChart: React.FC<IProps> = ({
    type,
    showLabel,
    data,
    total,
}) => {
    const isHorizontal = type === 'horizontal';

    const colors = generateColors(data.length);
    return (
        <BarChart
            notMerge={true}
            style={{ height: 500 }}
            option={{
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                    },
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    formatter: function (params: any) {
                        let tooltipContent = `<strong>${params[0].axisValue}</strong><br/>`; // Hiển thị giá trị trục X

                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        params.forEach((item: any) => {
                            tooltipContent += `
                <span style="display:inline-block;width:10px;height:10px;
                background-color:${item.color};border-radius:50%;margin-right:5px;"></span>${item.seriesName}:
                <strong>${getValueFromPercent(item.value, total, 0)}</strong><br/>`;
                        });

                        return tooltipContent;
                    },
                },
                legend: {
                    top: 10,
                    type: 'scroll',
                    icon: 'circle',
                },
                grid: {
                    left: '0%',
                    right: '5%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: isHorizontal
                    ? { type: 'value' }
                    : {
                          type: 'category',
                          data: ['Tổng hợp'],
                          axisLabel: {
                              formatter: function (value: string) {
                                  return value.length > 10
                                      ? value.substring(0, 10) + '...'
                                      : value;
                              },
                          },
                      },
                yAxis: isHorizontal
                    ? {
                          type: 'category',
                          data: ['Tổng hợp'],
                          axisLabel: {
                              formatter: function (value: string) {
                                  return value.length > 10
                                      ? value.substring(0, 10) + '...'
                                      : value;
                              },
                          },
                      }
                    : { type: 'value' },
                series: data.map((item, index) => {
                    return {
                        name: item.name,
                        type: 'bar',
                        stack: 'total',
                        barWidth: 'auto',
                        barMinWidth: 5,
                        barMaxWidth: 50,
                        data: [item.value_percent ?? 0],
                        itemStyle: {
                            color: colors[index],
                        },
                        label: {
                            show: showLabel,
                            position: isHorizontal ? 'right' : 'top',
                            formatter: (params: { value: number }) => {
                                return Number(params.value) === 0
                                    ? ''
                                    : params.value + '%';
                            },
                        },
                    };
                }),
            }}
        />
    );
};

export default QuestionStackedColumnChart;
